export default __webpack_public_path__ + "static/media/banner.1e2ee499.png";